import { LOCAL_DATE } from './date-time.constants';

export const DEFAULT_DATEPICKER_FORMAT = [ 'year', 'date', 'month' ];
export const DEFAULT_BASIC_DATEPICKER_FORMAT = 'DD MMMM, YYYY';
export const DEFAULT_DATERANGEPICKER_FORMAT = LOCAL_DATE;
export const DATEPICKER_FORMAT_YEARS = 'yyyy';
export const DATEPICKER_VIEW_YEARS = [ 'year' ];
